import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    updateShipTo as updateShipToApi,
    UpdateShipToApiParameter,
} from "@insite/client-framework/Services/CustomersService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<
    UpdateShipToApiParameter & HasOnSuccess<ShipToModel> & HasOnError<string>,
    ShipToModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await updateShipToApi(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            props.parameter.onError?.(error.errorMessage);
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadShipTo: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/CompleteLoadShipTo",
        model: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, DispatchCompleteLoadShipTo, ExecuteOnSuccessCallback];

const updateShipToAddress = createHandlerChainRunner(chain, "UpdateShipToAddress");
export default updateShipToAddress;